export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-force/src/constant.js
// module id = vWvZ
// module chunks = 0